/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ReportListPageComponent} from './report-list-page.component';

@Component({
  standalone: true,
  imports: [ReportListPageComponent],
  selector: 'adn-report-route-page',
  template: `
    <adn-report-list-page [readOnly]="readOnly">
    </adn-report-list-page>
  `
})
export class ReportRoutePageComponent {
  @Input() readOnly = false;
}
